import { render, staticRenderFns } from "./RingTreeTargetParsingSettings.vue?vue&type=template&id=035acd9a"
import script from "./RingTreeTargetParsingSettings.vue?vue&type=script&lang=js"
export * from "./RingTreeTargetParsingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports